export { CollaboratorService } from '../services/collaborator.service';

